export const FORM_TEL = () => {
  return [
    {
      name: 'telephone',
      type: 'INPUT_PHONE',
      label: 'เบอร์โทรศัพท์',
      placeholder: 'กรอกเบอร์โทรศัพท์',
      rules: {
        required: true,
        pattern: /^[0-9]{10}$/,
      },
      maxLength: 10,
    },
  ];
};
export const FORM_OTP = (otpRef = '') => {
  return [
    {
      name: 'lineUid',
      type: 'HIDDEN',
    },
    {
      name: 'lineName',
      type: 'HIDDEN',
    },
    {
      name: 'otpRef',
      type: 'HIDDEN',
    },
    {
      name: 'otpCode',
      type: 'INPUT',
      label: `รหัส OTP ${otpRef ? `[รหัสอ้างอิง: ${otpRef}]` : ''}`,
      placeholder: 'กรอกรหัส OTP',
      rules: {
        required: true,
      },
    },
  ];
};

export const FORM_POLICY_MODAL = () => {
  return [
    {
      name: 'policyText',
      type: 'INPUT_AREA',
      style: {
        height: '50vh',
      },
    },
    {
      name: 'checkPolicy',
      type: 'CHECKBOX',
      label: 'นโยบายและเงื่อนไขการให้บริการ',
      properties: { options: [{ label: 'ยอมรับ', value: true }] },
      rules: {
        required: true,
      },
    },
  ];
};
